export default "__VITE_ASSET__CvxNX7I6__"